import React from 'react';
import { AnyIfEmpty } from 'react-redux';
import { Carousel } from 'react-responsive-carousel';
import cardImg from '../../../images/no-unit-image.svg';
import styles from './Slider.module.css';

interface ISlider {
    carouselBanner: string;
    price: number;
}

const Slider = (props: ISlider) => {
    // const [isLoading, setIsLoading] = useState(true);
    // const [isInView, setIsInView] = useState(false);
    // const root = useRef<HTMLDivElement>(null);

    // useEffect(() => {
    //     const onIntersection = (entries: IntersectionObserverEntry[]) => {
    //         const { isIntersecting } = entries[0];

    //         if (isIntersecting) observer.disconnect();

    //         setIsInView(isIntersecting);
    //     };

    //     const observer = new IntersectionObserver(onIntersection, { threshold: 0 });

    //     if (null !== root.current) {
    //         observer.observe(root.current);
    //     }
    // }, []);

    // const onLoad = () => setIsLoading((prev) => !prev);
    let images: string[] = props?.carouselBanner?.split(',');
    if (images && images.length === 1 && images[0]?.trim() === '') {
        images = [cardImg];
    } else if (images && images.length === 0) {
        images = [cardImg];
    }

    return (
        <div className={styles.sliderContainer}>
            <Carousel showThumbs={false} autoPlay={true} infiniteLoop={true} showArrows={false} showStatus={false} emulateTouch>
                {images &&
                    images.map((item: AnyIfEmpty<object>, index: number) => {
                        return (
                            <div className={styles.sliderItem} key={index}>
                                <img className={styles.banner} src={item} />
                            </div>
                        );
                    })}
            </Carousel>
        </div>
    );
};

export default Slider;
